import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-function",
  "use": "icon-function-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"icon-function\">\n    \n    <g>\n    <path d=\"M4 4h10.667v10.667h-10.667v-10.667zM4 17.333h10.667v10.667h-10.667v-10.667zM17.333 4h10.667v10.667h-10.667v-10.667zM17.333 17.333h10.667v10.667h-10.667v-10.667zM20 6.667v5.333h5.333v-5.333h-5.333zM20 20v5.333h5.333v-5.333h-5.333zM6.667 6.667v5.333h5.333v-5.333h-5.333zM6.667 20v5.333h5.333v-5.333h-5.333z\" />\n    </g>\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol